import React, { useState, useEffect } from "react";
import CustomTable from "../../../components/table/table";
import "./view.css";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import {
  admin_challenge_opportunity_delete,
  get_challenge_opportunity_list,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOpportunity, setSelectedOpportunity] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showFilters, setShowFilters] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});

  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  const applyFilters = () => {
    let filtered = [...data];

    if (selectedOpportunity) {
      filtered = filtered.filter(item =>
        item.opportunity === selectedOpportunity
      );
    }

    if (selectedStatus !== "") {
      filtered = filtered.filter(item =>
        item.status_code === Number(selectedStatus)
      );
    }

    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.title && item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredData(filtered);
  };

  const getUniqueOpportunities = () => {
    const opportunities = [...new Set(data.map(item => item.opportunity).filter(Boolean))];
    return opportunities.sort();
  };

  const handleChallengeOpportunityList = async () => {
    setIsActive(true);
    try {
      const res = await get_challenge_opportunity_list();
      const tdata = Array.isArray(res)
        ? res.map((item, index) => ({
          ...item,
          slno: index + 1,
          opportunity:
            item?.market_analysis_opportunity?.opportunity ??
            item?.market_analysis_opportunity_name ??
            item?.opportunity ??
            "",
          status_code:
            String(item?.status).toLowerCase() === "pending" ||
              String(item?.status) === "0"
              ? 0
              : String(item?.status).toLowerCase() === "approved" ||
                String(item?.status) === "1"
                ? 1
                : String(item?.status).toLowerCase() === "rejected" ||
                  String(item?.status).toLowerCase() === "reject" ||
                  String(item?.status) === "2"
                  ? 2
                  : item?.status,
          image:
            item?.image && assetBaseUrl
              ? `${assetBaseUrl}/${String(item.image).replace(/^\//, "")}`
              : item?.image || "",
          brochure:
            item?.brochure && assetBaseUrl
              ? `${assetBaseUrl}/${String(item.brochure).replace(/^\//, "")}`
              : item?.brochure || "",
        }))
        : [];

      setData(tdata);
    } catch (error) {
      setData([]);
      setSnackMessage(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch challenge opportunity list"
      );
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    handleChallengeOpportunityList();
  }, []);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedOpportunity, selectedStatus, data]);

  useEffect(() => {
    return () => {
      setData([]);
      setFilteredData([]);
    };
  }, []);

  const handleEdit = (row) => {
    props.history.push({
      pathname: `/challenges-edit/${row.id}`,
      state: { row },
    });
  };

  const handleAddNew = () => {
    let path = "/challenges-add";
    props.history.push(path);
  };

  const handleView = (data) => {
    props.history.push({
      pathname: `/challenges-view/${data.id}`,
      state: { row: data },
    });
  };

  const handleDelete = (row) => {
    setActiveData(row);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (row) => {
    setOpenAction(false);
    setIsActive(true);
    admin_challenge_opportunity_delete(row.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
          error?.message ||
          "Failed to delete"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleChallengeOpportunityList();
    }
  };

  const getColumns = () => {
    const baseColumns = [
      { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
      { title: "Opportunity", field: "opportunity" },
      { title: "Title", field: "title" },
      { title: "Description", field: "description" },
      { title: "Due Date", field: "due_date" },
    ];
    if (adminType === 23) {
      return [
        ...baseColumns,
        { title: "Site URL", field: "site_url" },
        { title: "Status", field: "status_code", type: "mouStatus" },
        { title: "Image", field: "image", type: "imageFull" },
      ];
    }
    return [
      ...baseColumns,
      { title: "Status", field: "status_code", type: "mouStatus" },
    ];
  };

  const getActions = () => {
    if (adminType === 1) {
      return [
        { type: "view", handleClick: handleView },
        { type: "edit", handleClick: handleEdit },
      ];
    }
    if (adminType === 2) {
      return [
        { type: "view", handleClick: handleView },
        { type: "delete", handleClick: handleDelete },
      ];
    }
    return [
      { type: "view", handleClick: handleView },
    ];
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Challenges</b>
          </h5>
          <div className="d-flex gap-2">
            {adminType === 1 && (
              <button
                className="btn btn-primary btn-sm search-style border-0 text-white rounded"
                onClick={handleAddNew}
              >
                Add New
              </button>
            )}
            <button
              className={`filter-icon-btn ${showFilters ? "active" : ""}`}
              onClick={() => setShowFilters(!showFilters)}
              title="Toggle Filters"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end mb-3">
              <div className="col-md-3">
                <label className="form-label small">Opportunity</label>
                <select
                  className="form-control filter-select"
                  value={selectedOpportunity}
                  onChange={(e) => setSelectedOpportunity(e.target.value)}
                >
                  <option value="">All Opportunities</option>
                  {getUniqueOpportunities().map((opp, index) => (
                    <option key={index} value={opp}>{opp}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small">Status</label>
                <select
                  className="form-control filter-select"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">All Statuses</option>
                  <option value="0">Pending</option>
                  <option value="1">Approved</option>
                  <option value="2">Rejected</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small">Title</label>
                <input
                  type="text"
                  className="form-control filter-select"
                  placeholder="Search by title..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-3 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset Filters"
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedOpportunity("");
                    setSelectedStatus("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
                <button
                  className="filter-action-btn close-btn"
                  title="Close Filters"
                  onClick={() => setShowFilters(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <CustomTable
            {...props}
            columns={getColumns()}
            data={filteredData}
            actions={getActions()}
          />
        </div>
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Challenge ?"
          data={activeData}
          message="Are you sure to Delete this Challenge?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
